<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('create')}} {{t('branch-office')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/masters/branch-offices" class="d-inline-block position-relative">
                    {{t('Branch offices')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('create')}} {{t('branch-office')}}
            </li>
        </ol>
    </div>

    <!-- Create Branch Office -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <form [formGroup]="addBranchOfficeForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('name')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-name')}}
                                </mat-label>
                                <input matInput type="text" id="name" formControlName="name" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('address')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-address')}}
                                </mat-label>
                                <input matInput type="text" id="address" formControlName="address" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-company')}}
                                </mat-label>
                                <mat-select formControlName="companyId" required>
                                    <mat-option *ngFor="let company of companies" [value]="company.id">
                                        {{company.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button mat-button type="submit" [disabled]="addBranchOfficeForm.invalid">
                        {{t('create')}} {{t('branch-office')}}
                    </button>
                    <a mat-button routerLink="/masters/branch-offices">
                        {{t('cancel')}}
                    </a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-container>
